import styled from "styled-components";
import {
  challenges1,
  challenges2,
  challenges3,
  challenges4,
  challenges5
} from "../../../assets/images";

const Challenges = () => {
  const rowChallenges = [
    { title: "Declining enrollment /low retention", imageBg: challenges1 },
    { title: "Lack of Digital Engagement", imageBg: challenges2 },
    { title: "Budget constraints / misaligned support", imageBg: challenges3 },
    { title: "Retention Rates", imageBg: challenges4 },
    { title: "Limited Personalization", imageBg: challenges5 }
  ];

  return (
    <ChallengesSection>
      <MainContainer>
        <HeaderContainer>
          <Subtitle>Challenges</Subtitle>
          <TitleWrapper>
            <MainTitle>Smart Solutions for Real Campus Challenges</MainTitle>
          </TitleWrapper>
        </HeaderContainer>
        

        <ContentArea>
          <CardsRow>
            {rowChallenges.map((challenge, index) => (
              <CardContainer key={index}>
                <CardContent>
                  <ImagePlaceholder $imageBg={challenge.imageBg} role="img" aria-label={challenge.title + " illustration"}  />
                  <TextContainer>
                    <CardTitle>{challenge.title}</CardTitle>
                  </TextContainer>
                </CardContent>
              </CardContainer>
            ))}
          </CardsRow>
        </ContentArea>

      </MainContainer>
    </ChallengesSection>
  );
};

export default Challenges;


const MainContainer = styled.div`
  width: 100%;
`;

const HeaderContainer = styled.header`
  text-align: center;
  color: #fff;
`;

const Subtitle = styled.h2`
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 0;
`;


const MainTitle = styled.h3`
  margin: 0 auto;
  max-width: 800px;
  font-weight: 700;
`;



const ChallengesSection = styled.section`
  background: linear-gradient(#232731 10%, #2d2455 100%, #232731 10%);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Inter, -apple-system, Roboto, Helvetica, sans-serif;
  padding: 60px 20px 90px;
  overflow: hidden;

  /* MOBILE ONLY */
  @media (max-width: 640px) {
    padding: 43px 16px 49px;
  }
`;

const TitleWrapper = styled.div`
  margin-top: 20px;
  font-size: 40px;
  line-height: 1.4;

  @media (max-width: 991px) {
    font-size: 32px;
    line-height: 1.3;
  }

  /* MOBILE ONLY */
  @media (max-width: 640px) {
    font-size: 20px;
    margin-bottom: 27px;
    line-height: 1.2;
  }
`;

const ContentArea = styled.div`
  margin-top: 60px;

  /* MOBILE ONLY */
  @media (max-width: 640px) {
    margin-top: 16px;
  }
`;

const CardsRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 57px 43px;
  flex-wrap: wrap;

  /* MOBILE ONLY */
  @media (max-width: 640px) {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px; /* tighter vertical rhythm */
  }
`;

const CardContainer = styled.div`
  width: 240px; 
  height: 240px;
  display: flex;
  flex-direction: column;

  /* MOBILE ONLY */
  @media (max-width: 640px) {
    width: 100%;
    height: auto; /* let content define height */
  }
`;

const CardContent = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 18px;
  height: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  /* MOBILE ONLY: compact row item */
  @media (max-width: 640px) {
    border-radius: 12px;
    padding: 10px 12px 10px 16px;
    min-height: 56px;
    height: auto;
    flex-direction: row;
    align-items: center;
    position: relative;

    /* left accent bar */
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 8px;
      bottom: 8px;
      width: 4px;
      border-radius: 4px;
      background: linear-gradient(180deg, #6a37e3, #9b6cff);
      opacity: 0.9;
    }
  }
`;

const ImagePlaceholder = styled.div`
  width: 100%;
  height: 240px;
  background: ${({ $imageBg }) => `url(${$imageBg}) center / cover no-repeat`};
  border-radius: 9px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);

  @media(max-width: 640px) {
    display: none;
  }
`;

const TextContainer = styled.div`
  margin-top: 16px;
  text-align: center;
  width: 100%;
  margin-left:10px;
  margin-right:10px;

  /* MOBILE ONLY */
  @media (max-width: 640px) {
    margin: 0 6px 0 0;
    text-align: left;
  }
`;

const CardTitle = styled.h4`
  font-size: 18px;
  font-weight: 600;
  color: #1c1b1f;
  margin: 0;

  /* MOBILE ONLY: single line + ellipsis */
  @media (max-width: 640px) {
    font-size: 15px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
